module.exports = __webpack_public_path__ + "static/media/ar-SA.de2fc643.md";